<template>
  <ContainerScrolling class="CategoryDashboard">
    <LayoutFill :no-gutters="solidHeader" :no-padding="solidHeader">
      <MainBanner
        :category="selectedCategory"
        :solid-header="solidHeader"
        :rss-feed="true"
        :search="true"
      />
    </LayoutFill>

    <LayoutGutters>
      <v-row class="mt-md-4">
        <ArticleMostPopular
          id="most-read-content"
          :selected-article="selectedCategory.mostReadItem"
          :title="articleMostReadTitle"
          :show-content-type="showContentTypeSubject"
        />
        <ArticleMostPopular
          v-if="showMostCitedItem"
          id="most-cited-content"
          :selected-article="selectedCategory.mostCitedItem"
          :title="articleMostCitedTitle"
          :show-content-type="showContentTypeSubject"
        />
      </v-row>

      <v-row mt-4>
        <v-col>
          <SelectedArticles
            title="Latest Content"
            :articles="selectedCategory.latestItems"
            :show-content-type="showContentTypeSubject"
            :show-large-title="false"
          />
        </v-col>
      </v-row>
      <v-row mt-4 mb-4>
        <v-col>
          <v-div text-center>
            <v-btn
              class="toLatestListing"
              outlined
              rounded
              @click="viewMoreRedirect"
            >
              View More
              <span class="d-sr-only"
                >&nbsp;Latest Content in {{ selectedCategory.name }}</span
              >
            </v-btn>
          </v-div>
        </v-col>
      </v-row>
    </LayoutGutters>
  </ContainerScrolling>
</template>

<script>
import { mapState } from "vuex";
import mapFlags from "~/plugins/utilities/mapFlags";
import buildActionDispatcher from "~/actions/utilities/buildActionDispatcher";

import ContainerScrolling from "~/components/layout/ContainerScrolling.vue";
import LayoutFill from "~/components/layout/LayoutFill.vue";
import LayoutGutters from "~/components/layout/LayoutGutters";

import MainBanner from "~/components/banner/MainBanner.vue";
import SelectedArticles from "~/components/articles/SelectedArticles.vue";
import ArticleMostPopular from "~/components/articles/ArticleMostPopular.vue";

import toCanonicalUrl from "~/plugins/utilities/toCanonicalUrl.js";
import getPageTitle from "~/plugins/utilities/getPageTitle.js";
import getSiteName from "~/plugins/utilities/getSiteName.js";

export default {
  name: "CategoryDashboard",
  components: {
    ContainerScrolling,
    LayoutFill,
    LayoutGutters,
    MainBanner,
    ArticleMostPopular,
    SelectedArticles,
  },
  data() {
    return {
      articleMostReadTitle: "Most Read",
      articleMostCitedTitle: "Most Cited",
    };
  },
  fetch: buildActionDispatcher("loadCategoryDashboard"),
  head() {
    const { selectedCategory, siteName, domain, partner } = this;

    const title = getPageTitle(siteName);
    const pageTitle =
      selectedCategory.name + " | Early Research Outputs | " + title;

    const canonicalUrl = toCanonicalUrl(
      `category-dashboard/${selectedCategory.id}`,
      partner
    );
    const cupTechText = "brought to you by";

    return {
      title: pageTitle,

      meta: [
        {
          hid: "description",
          name: "description",
          content: `Browse ${selectedCategory.name} to discover early research outputs in ${domain} on ${siteName}, ${cupTechText} Cambridge University Press.`,
        },
      ],
      link: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  computed: {
    ...mapState({
      layout: (state) => state.theme.layout,
      siteName: (state) => getSiteName(state.theme),
      domain: (state) => state.theme.domain,
      selectedCategory: (state) => state.selectedCategory,
    }),
    ...mapFlags(["showContentTypeSubject"]),
    partner() {
      return this.$config.partner;
    },
    solidHeader() {
      return this.layout.mainBannerSolidHeader;
    },
    showMostCitedItem() {
      return this.selectedCategory.mostCitedItem?.citationsCount;
    },
  },
  methods: {
    viewMoreRedirect() {
      const redirectPath = `/engage/${this.partner}/search-dashboard?categories=${this.selectedCategory.id}&sortBy=PUBLISHED_DATE_DESC`;
      return this.$router.push(redirectPath);
    },
  },
};
</script>
